import Vue from 'vue';
import Toasted from 'vue-toasted';

Vue.use(Toasted, { "duration": 3000, "action": { "text": "×", "onClick": function onClick(e, toast) {
      toast.goAway(0);
    } } });

export default function (ctx, inject) {
  inject('toast', Vue.toasted);
}


//////////////////
// WEBPACK FOOTER
// ./.nuxt/toast.js
// module id = ./.nuxt/toast.js
// module chunks = 152